import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MobileMenuService } from '../../../../shared/services/mobile-menu.service';
import { data } from 'src/app/data';

@Component({
    selector: 'app-mobile-menu',
    templateUrl: './mobile-menu.component.html',
    styleUrls: ['./mobile-menu.component.scss']
})
export class MobileMenuComponent implements OnDestroy, OnInit {
    private destroy$: Subject<any> = new Subject();

    isOpen = false;
    links= [];

    constructor(public mobilemenu: MobileMenuService) { }

    ngOnInit(): void {
        this.mobilemenu.isOpen$.pipe(takeUntil(this.destroy$)).subscribe(isOpen => this.isOpen = isOpen);
        this.links = [
            { type: 'link', name: 'Home', slug: '/' },
            {
                name: 'Inventory', slug: '', children: data.categories
            },            
            // { type: 'link', name: 'Brands', slug: '/brands' },
            // { type: 'link', name: 'Trends', slug: '/tags/trends' },
            { type: 'link', name: 'About Us', slug: '/home/about-us' },
            { type: 'link', name: 'Contact Us', slug: '/home/contact-us' }, 
        {type: 'link',name: 'Request For Quote', slug: '/home/getquote'},

           
        ];

    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onItemClick(event): void {
        this.mobilemenu.close();
    }
}
